import { useState } from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { GridWrapper } from './styles';
import { AgGridReact } from 'ag-grid-react';
import {
    IHeaderParams, GridApi, ColumnApi, GridReadyEvent,
    ValueGetterParams, FirstDataRenderedEvent, ICellRendererParams, GridSizeChangedEvent, SortChangedEvent, ViewportChangedEvent, ColDef
} from 'ag-grid-community';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { ISerologyTransactionDetails } from '@nkr/models/index';

interface IProps {
    reportList: ISerologyTransactionDetails[],
}

const VrlTransDetailGridSerology = (props: IProps) => {
    const [gridApi, setGridApi] = useState<GridApi>(null);
    const [columnApi, setColumnApi] = useState<ColumnApi>(null);
    const [columns, setColumns] = useState<ColDef[]>([
        {
            colId: 'Rank',
            field: 'rank',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Row #
                </SortableHeaderComponent>,
            headerName: 'Row #',
            maxWidth: 55,
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            resizable: true,
            suppressSizeToFit: true,
            valueGetter: (props: ValueGetterParams) => props.node.rowIndex + 1
        },
        {
            colId: 'orderId',
            field: 'orderId',
            headerName: 'Order ID',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Order ID
                </SortableHeaderComponent>,
            width: 55,
            sortable: true,
            resizable: true,
            suppressSizeToFit: true
        },
        {
            colId: 'donorCenter',
            field: 'donorCenter',
            headerName: 'Donor Center',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Donor Center
                </SortableHeaderComponent>,
            minWidth: 120,
            sortable: true,
            // sort: 'asc',
            resizable: true
        },
        {
            colId: 'donorAlias',
            field: 'donorAlias',
            headerName: 'Donor Alias',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Donor Alias
                </SortableHeaderComponent>,
            minWidth: 120,
            cellRendererFramework: (props: ICellRendererParams) => {
                let { donorAlias, donorId, donorCenterId } = props.data;

                return (donorId > 0
                    ? <a target={'_blank'} href={`center/${donorCenterId}/donor/${donorId}/profile/donor-data`}>{donorAlias}</a>
                    : <span>{donorAlias}</span>)
            },
            sortable: true,
            // sort: 'asc',
            resizable: true
        },
        {
            colId: 'recipientCenter',
            field: 'recipientCenter',
            headerName: 'Recipient Center',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Recipient Center
                </SortableHeaderComponent>,
            minWidth: 100,
            sortable: true,
            resizable: true
        },
        {
            colId: 'recipientAlias',
            field: 'recipientAlias',
            headerName: 'Recipient Alias',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Recipient Alias
                </SortableHeaderComponent>,
            cellRendererFramework: (props: ICellRendererParams) => {
                let { recipientAlias, recipientId, recipientCenterId } = props.data;

                return (recipientId > 0
                    ? <a target={'_blank'} href={`center/${recipientCenterId}/recipient/${recipientId}/profile/general`}>{recipientAlias}</a>
                    : <span>{recipientAlias}</span>)
            },
            minWidth: 100,
            sortable: true,
            resizable: true,
        },
        {
            colId: 'swapNumber',
            field: 'swapNumber',
            headerName: 'Swap Number',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Swap #
                </SortableHeaderComponent>,
            width: 60,
            sortable: true,
            resizable: true
        },
        {
            colId: 'clusterNumber',
            field: 'clusterNumber',
            headerName: 'Cluster Number',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Cluster #
                </SortableHeaderComponent>,
            width: 60,
            sortable: true,
            resizable: true
        },
        {
            colId: 'position',
            field: 'position',
            headerName: 'Position',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Position #
                </SortableHeaderComponent>,
            width: 60,
            sortable: true,
            resizable: true
        },
        {
            colId: 'shipBackDate',
            field: 'shipBackDate',
            headerName: 'Ship Back Date',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Ship Back Date
                </SortableHeaderComponent>,
            minWidth: 100,
            maxWidth: 120,
            sortable: true,
            resizable: true,
            cellRendererFramework: (props: ICellRendererParams) => {
                var shipBackDate = props.data.shipBackDate;
                if (moment(shipBackDate).isValid()) {
                    return (moment(shipBackDate).format('MM/DD/YYYY'))
                } else {
                    return "--";
                }
            }
        },
        {
            colId: 'requestedDate',
            field: 'requestedDate',
            headerName: 'Requested Date',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Requested<br />Date
                </SortableHeaderComponent>,
            minWidth: 100,
            maxWidth: 120,
            sortable: true,
            resizable: true,
            cellRendererFramework: (props: ICellRendererParams) => {
                if (props.data.requestedDate !== null)
                    return (moment(props.data.requestedDate).format('MM/DD/YYYY'))
                else
                    return '--';
            }
        },
        {
            colId: 'completed',
            field: 'completed',
            headerName: 'Completed',
            cellClass: 'center-list-cell',
            headerClass: 'center-list-header',
            headerComponentFramework: (props: IHeaderParams) =>
                <SortableHeaderComponent {...props}>
                    Completed<br />Date
                </SortableHeaderComponent>,
            minWidth: 100,
            maxWidth: 120,
            sortable: true,
            sort: 'desc',
            cellRendererFramework: (props: ICellRendererParams) => {
                if (props.data.completed !== null)
                    return (moment(props.data.completed).format('MM/DD/YYYY'))
                else
                    return '--';
            }
        }
    ]);

    const onGridReady = (e: GridReadyEvent) => {
        setGridApi(e.api);
        setColumnApi(e.columnApi)

        e.api.sizeColumnsToFit();
    };

    const onViewportChanged = (e: ViewportChangedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const onGridSizeChanged = (e: GridSizeChangedEvent) => {
        // get the current grids width
        let gridWidth = document.getElementById('grid-wrapper').offsetWidth;

        // keep track of which columns to hide/show
        let columnsToShow = [];
        let columnsToHide = [];

        // iterate over all columns (visible or not) and work out
        // now many columns can fit (based on their minWidth)
        let totalColsWidth = 0;
        let allColumns = columnApi.getAllColumns();

        for (let i = 0; i < allColumns.length; i++) {
            let column = allColumns[i];
            totalColsWidth += column.getMinWidth();

            if (totalColsWidth > gridWidth) {
                columnsToHide.push(column.getColId);
            } else {
                columnsToShow.push(column.getColId);
            }
        }

        // show/hide columns based on current grid width
        columnApi.setColumnsVisible(columnsToShow, true);
        columnApi.setColumnsVisible(columnsToHide, false);

        // fill out any available space to ensure there are no gaps
        gridApi.sizeColumnsToFit();
    };

    const onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    };

    const onSortChanged = (e: SortChangedEvent) => {
        e.api.refreshCells();
    };

    return (
        <>
            <div className='row'>
                <div className='col-sm-12'>
                    <GridWrapper id='grid-wrapper' className='container-fluid-max-sm ag-theme-bootstrap' style={{ marginBottom: 20 }}>
                        <AgGridReact
                            onGridReady={onGridReady}
                            onGridSizeChanged={onGridSizeChanged}
                            onFirstDataRendered={onFirstDataRendered}
                            enableCellTextSelection={true}
                            onViewportChanged={onViewportChanged}
                            enableRangeSelection={true}
                            columnDefs={columns}
                            rowData={props.reportList}
                            headerHeight={60}
                            noRowsOverlayComponentFramework={() => <div>No data for the selected date range...</div>}
                            suppressCellSelection={true}
                            onSortChanged={onSortChanged}
                        />
                    </GridWrapper>
                </div>
            </div>
        </>
    );
}

export default VrlTransDetailGridSerology;